var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{class:_vm.className,attrs:{"disabled":_vm.disabled,"loading":_vm.loading,"type":"default","htmlType":"button"},on:{"click":_vm.flushPageView}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }